const FrenchPolynesiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111448)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.43164 10.4348H37.568C34.1759 4.21789 27.5807 0 19.9998 0C12.419 0 5.82375 4.21789 2.43164 10.4348Z"
        fill="#D80027"
      />
      <path
        d="M19.9998 40.0002C27.5807 40.0002 34.1759 35.7823 37.568 29.5654H2.43164C5.82375 35.7823 12.419 40.0002 19.9998 40.0002Z"
        fill="#D80027"
      />
      <path
        d="M26.9564 19.9995C26.9564 23.8415 23.8419 26.0864 19.9999 26.0864C16.158 26.0864 13.0435 23.8415 13.0435 19.9995C13.0435 16.1574 16.158 13.043 19.9999 13.043C23.8419 13.043 26.9564 16.1574 26.9564 19.9995Z"
        fill="#FFDA44"
      />
      <path
        d="M26.9564 20C26.9564 23.842 23.8419 26.9565 19.9999 26.9565C16.158 26.9565 13.0435 23.842 13.0435 20"
        fill="#0052B4"
      />
      <path d="M15.6519 18.2598H17.391V21.738H15.6519V18.2598Z" fill="#D80027" />
      <path d="M22.6089 18.2598H24.348V21.738H22.6089V18.2598Z" fill="#D80027" />
      <path d="M19.1304 15.6514H20.8695V21.7383H19.1304V15.6514Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_4152_111448">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default FrenchPolynesiaSvg;
